import { useTranslation } from 'react-i18next';
import type { SellerOrganizationPickerLabels } from '~/components/common/SellerOrganizationPicker';

type WizardSellerPickerLabels = Pick<
  SellerOrganizationPickerLabels,
  'loading' | 'error' | 'emptyMessage'
>;

export function useBuyListSellerPickerLabels(
  wizardLabels: WizardSellerPickerLabels
): SellerOrganizationPickerLabels {
  const { t } = useTranslation('inventory');
  return {
    searchPlaceholder: t('inventory.buy_list.seller_picker.search_placeholder'),
    searchLabel: t('inventory.buy_list.seller_picker.search_label'),
    emptyTitle: t('inventory.buy_list.seller_picker.no_sellers_title'),
    noResultsTitle: t(
      'inventory.buy_list.seller_picker.no_seller_matches_title'
    ),
    noResultsMessage: t('inventory.buy_list.seller_picker.no_seller_matches'),
    ...wizardLabels,
  };
}
